import { get } from 'lodash-es';

export const productDetailsProductId = (state) => get(state, 'productId');
export const productDetailsIsLoading = (state) => get(state, 'productDetailsIsLoading');
export const productProfiles = (state) => get(state, 'productProfiles');
export const shouldUseAggregateInventory = (state) => get(state, 'shouldUseAggregateInventory');
export const productImportStarted = (state) => get(state, 'importProductsStarted');
export const productImportCompleted = (state) => get(state, 'importProductsComplete');
export const productExportStarted = (state) => get(state, 'exportProductsStarted');
export const productExportCompleted = (state) => get(state, 'exportProductsComplete');
